export default __webpack_public_path__ + "static/media/ukFlag.06b2858f.svg";